import FroalaEditor from "froala-editor";
import jQuery from "jquery";

if (!window.jQuery) {
  window.jQuery = window.$ = jQuery;
}

window.FroalaEditor = FroalaEditor;

declare global {
  interface Window {
    FroalaEditor: typeof FroalaEditor
  }
}
